module.exports = __webpack_public_path__ + "static/media/Cordier3.d58a529d.jpg";